import React from 'react';
import { Card } from 'primereact/card';

export default function ReportsPage() {
  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ marginTop: 0 }}>Reports & Analytics</h2>
      <Card className="cyber-card">
        <p style={{ margin: 0 }}>Dummy charts and KPIs will be placed here (conversion rate, order trends, utilization).</p>
      </Card>
    </div>
  );
}